import splitFract from './splitFract'

let {max} = Math

let updateLen = (n, curLen) => {
	let [beforeDot, afterDot = ''] = splitFract(n)
	return [
		max(beforeDot.length, curLen[0]),
		max(afterDot.length, curLen[1])
	]
}

export default updateLen


/** WEBPACK FOOTER **
 ** ./src/scripts/lib/updateLen.js
 **/